import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const Loader = () => (
  <Box width="100%" flexDirection="column" data-testid="mfa-loader">
    <Box mb={3}>
      <Skeleton height="24px" width="50%" />
    </Box>

    <Box>
      <Skeleton height="17px" width="100%" />
    </Box>
    <Box>
      <Skeleton height="17px" width="100%" />
    </Box>

    <Box mt={6}>
      <Skeleton height="65px" width="100%" />
    </Box>

    <Box mt={3}>
      <Skeleton height="17px" width="80%" />
    </Box>

    <Box alignSelf="end" mt={6}>
      <Skeleton height="35px" width="86px" />
    </Box>
  </Box>
);

export default Loader;
